import type { Language } from '../useLanguages';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const changeLanguageAction = (language: Language) => ({
  type: CHANGE_LANGUAGE,
  payload: language,
});
